export const ACTIVE_ITEM = 'ACTIVE_ITEM'
export const TOGGLE_SUBMENU = 'TOGGLE_SUBMENU'
